/**
 * Gemeinsame Typen für Teilnehmer-Tokens (§7, §8.1).
 *
 * Enthält **keinen** Klartext-Token. Die maskierte Darstellung ist der Regelfall (§7.9); die
 * Ausgabeansicht liefert Klartext über einen eigenen Typ, der ausdrücklich als solcher benannt
 * ist.
 */
/** Dauerhafter Verwaltungsstatus eines Tokens. */
export const TOKENSTATUS_WERTE = ['unbenutzt', 'gesperrt', 'ersetzt'];
export const TOKENSTATUS_BESCHRIFTUNG = {
    unbenutzt: 'Unbenutzt',
    gesperrt: 'Gesperrt',
    ersetzt: 'Ersetzt',
};
/**
 * Anzeigestatus eines Tokens (§7.6).
 *
 * §7.6 nennt sechs Werte. Drei davon sind dauerhafte Verwaltungszustände
 * ({@link TOKENSTATUS_WERTE}), die übrigen drei ergeben sich aus Anwesenheit und Sitzung und
 * werden hergeleitet — sie stehen deshalb nicht in der Datenbank.
 */
export const TOKEN_ANZEIGESTATUS_WERTE = [
    'unbenutzt',
    'angemeldet',
    'sitzung_getrennt',
    'abgemeldet',
    'gesperrt',
    'ersetzt',
];
export const TOKEN_ANZEIGESTATUS_BESCHRIFTUNG = {
    unbenutzt: 'Unbenutzt',
    angemeldet: 'Angemeldet',
    sitzung_getrennt: 'Sitzung getrennt',
    abgemeldet: 'Abgemeldet',
    gesperrt: 'Gesperrt',
    ersetzt: 'Ersetzt',
};
//# sourceMappingURL=token.js.map